module.exports = __webpack_public_path__ + "media/images/common/logo_bg_01-70d5c125c25caa545ef8f7cd92bd229e.png";